module.exports = __webpack_public_path__ + "media/images/area-badges/make-better-ee7ef2ba127378bbd94ad0a24f90784c.svg";